import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { styles, colors } from '../components/UI';

export default function ForgotPassword() {
  const [username, setUsername] = useState('');
  const [website, setWebsite] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await api.forgotPassword(username.trim(), website);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally { setBusy(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: colors.charcoal, padding: 16
    }}>
      <form onSubmit={submit} style={{
        background: '#fff', borderRadius: 10, width: '100%', maxWidth: 400,
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)', overflow: 'hidden'
      }}>
        <img src="/sss-logo.jpg" alt="Select Safety Services" style={{ width: '100%', display: 'block' }} />
        <div style={{ padding: 24, textAlign: 'center', borderBottom: '1px solid #E5E7EB' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: colors.textMuted, letterSpacing: 1 }}>RESET PASSWORD</div>
        </div>
        <div style={{ padding: 28 }}>
          {sent ? (
            <>
              <div style={{ background: '#D1FAE5', color: '#065F46', padding: '12px 14px', borderRadius: 6, fontSize: 14, marginBottom: 16, lineHeight: 1.5 }}>
                If an account matches <strong>{username}</strong>, a password reset link is on its way to the email on file. Check your inbox — the link expires in 1 hour.
              </div>
              <Link to="/login" style={{ display: 'block', textAlign: 'center', color: colors.orange, textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>
                ← Back to sign in
              </Link>
            </>
          ) : (
            <>
              {error && <div style={styles.errorBox}>{error}</div>}
              <p style={{ fontSize: 13, color: '#6B7280', margin: '0 0 16px 0', lineHeight: 1.5 }}>
                Enter your username (or the email on file) and we'll send a reset link.
              </p>
              <div style={{ marginBottom: 18 }}>
                <label style={styles.label}>Username or email</label>
                <input type="text" name="website" value={website} onChange={e => setWebsite(e.target.value)}
                  tabIndex={-1} autoComplete="off" aria-hidden="true"
                  style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }} />
                <input style={styles.input} value={username} onChange={e => setUsername(e.target.value)} autoFocus required />
              </div>
              <button type="submit" disabled={busy || !username.trim()} style={{ ...styles.btn, width: '100%', padding: '10px' }}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
              <div style={{ marginTop: 14, textAlign: 'center' }}>
                <Link to="/login" style={{ color: colors.orange, textDecoration: 'none', fontWeight: 600, fontSize: 13 }}>
                  ← Back to sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
